<template>
    <div class="landing-page manage-booking ">
        <!-- Top navbar -->
        <landing-page-navbar></landing-page-navbar>

        <div class="content-container">

            <!-- Contact cards -->
            <div class="container">
                <div class="row">
                    <div class="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                        <h2 v-if="countryCodeSetting === 'UK'">{{ $t('bp.ManageBookingIndex.titleUk') }}</h2>
                        <h2 v-if="countryCodeSetting !== 'UK'">{{ $t('bp.ManageBookingIndex.title') }}</h2>

                        <b-tabs v-model="tabIndex" justified :nav-class="[{'grid-col-3 card-grid row': allowsInStoreBooking},  'grid-col-2 card-grid row']">

                            <!-- Manage booking -->
                            <b-tab :title-item-class="tabItemClass(0)" title-link-class="card-body">
                                <template #title>
                                    <div class="card-img device-type">
                                        <icon-tools class="icon-all-text-colour mx-auto" size="2x"></icon-tools>
                                    </div>
                                    <p>{{ $t('bp.ManageBookingIndex.manageBooking') }}</p>
                                </template>
                                <div class="card card-body">
                                    <h4 class="mb-4">{{ $t('bp.ManageBookingIndex.title') }}</h4>
                                    <div class="form-group">
                                        <label>{{ $t('bp.ManageBookingIndex.enterEmail') }}</label>
                                        <input type="email" class="form-control" v-model="manageBooking.email" :class="{'is-invalid': error.manageBookingEmail}" v-on:keyup.enter="findManageBookingOrder()" />
                                        <div class="invalid-feedback" v-if="error.manageBookingEmail">{{ $t('bp.ManageBookingIndex.emailMissing') }}</div>
                                    </div>
                                    <div class="form-group">
                                        <label>
                                            {{ $t('bp.ManageBookingIndex.enterOrder') }}
                                            <div class="d-block d-sm-none"></div>
                                            <span class="text-link text-sm text-underline" v-b-modal.order-id-help-modal>{{ $t('bp.ManageBookingIndex.whereToFindOrder') }}</span>
                                        </label>
                                        <input type="email" class="form-control" v-model="manageBooking.orderRef" :class="{'is-invalid': error.manageBookingOrderRef}" v-on:keyup.enter="findManageBookingOrder()" />
                                        <div class="invalid-feedback" v-if="error.manageBookingOrderRef">{{ $t('bp.ManageBookingIndex.orderMissing') }}</div>
                                    </div>
                                    <button class="btn continue-btn btn-lg" @click="findManageBookingOrder()">{{ $t('bp.ManageBookingIndex.findOrder') }}</button>
                                </div>
                            </b-tab>

                            <!-- Track technician -->
                            <b-tab :title-item-class="tabItemClass(1)" title-link-class="card-body" v-if="countryCodeSetting === 'UK'">
                                <template #title>
                                    <div class="card-img device-type">
                                        <icon-van class="icon-all-text-colour mx-auto" size="2x"></icon-van>
                                    </div>
                                    <p>{{ $t('bp.ManageBookingIndex.trackTechnician') }}</p>
                                </template>
                                <div class="card card-body">
                                    <h4 class="mb-4">{{ $t('bp.ManageBookingIndex.trackYourTechnician') }}</h4>
                                    <div class="form-group">
                                        <label>{{ $t('bp.ManageBookingIndex.enterEmail') }}</label>
                                        <input type="email" class="form-control" v-model="technicianTracking.email" :class="{'is-invalid': error.technicianTrackingEmail}" v-on:keyup.enter="findTechnicianTrackingOrder()" />
                                        <div class="invalid-feedback" v-if="error.technicianTrackingEmail">{{ $t('bp.ManageBookingIndex.emailMissing') }}</div>
                                    </div>
                                    <div class="form-group">
                                        <label>
                                            {{ $t('bp.ManageBookingIndex.enterOrder') }}
                                            <div class="d-block d-sm-none"></div>
                                            <span class="text-link text-sm text-underline" v-b-modal.order-id-help-modal>{{ $t('bp.ManageBookingIndex.whereToFindOrder') }}</span>
                                        </label>
                                        <input type="email" class="form-control" v-model="technicianTracking.orderRef" :class="{'is-invalid': error.technicianTrackingOrderRef}" v-on:keyup.enter="findTechnicianTrackingOrder()" />
                                        <div class="invalid-feedback" v-if="error.technicianTrackingOrderRef">{{ $t('bp.ManageBookingIndex.orderMissing') }}</div>
                                    </div>
                                    <button class="btn continue-btn btn-lg" @click="findTechnicianTrackingOrder()">{{ $t('bp.ManageBookingIndex.trackTechnician') }}</button>
                                </div>
                            </b-tab>

                            <!-- Pre-booked order -->
                            <b-tab :title-item-class="tabItemClass(2)" title-link-class="card-body" lazy v-if="allowsInStoreBooking">
                                <template #title>
                                    <div class="card-img device-type">
                                        <icon-qr-code class="icon-all-text-colour mx-auto" size="2x"></icon-qr-code>
                                    </div>
                                    <p>{{ $t('bp.ManageBookingIndex.completePreBooking') }}</p>
                                </template>
                                <div class="card card-body">
                                    <h4 class="mb-4">{{ $t('bp.ManageBookingIndex.completePreBookedRepair') }}</h4>
                                    <pre-booking-completion-form></pre-booking-completion-form>
                                </div>
                            </b-tab>

                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>

        <!-- Footer -->
        <page-footer></page-footer>

        <b-modal id="order-id-help-modal" :title="$t('bp.ManageBookingIndex.whereToFindOrderQuestion')" ok-only>
            <p>
                {{ $t('bp.ManageBookingIndex.whereToFindOrderAnswer') }}
            </p>
        </b-modal>

    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    data() {
        return {
            error: {
                manageBookingEmail: false,
                manageBookingOrderRef: false,
                technicianTrackingEmail: false,
                technicianTrackingOrderRef: false,
            },
            manageBooking: {
                email: null,
                orderRef: null
            },
            tabIndex: 0,
            technicianTracking: {
                email: null,
                orderRef: null
            }
        }
    },

    computed: {
        ...mapGetters([
            'allowsInStoreBooking',
            'countryCodeSetting'
        ])
    },

    mounted() {
        this.resetErrors();
    },

    // Watch the tabindex change
    watch: {
        tabIndex() {
            this.resetErrors();
        }
    },

    methods: {
        /** Find manage booking order **/
        findManageBookingOrder() {
            this.resetErrors();

            if (!this.manageBooking.email) {
                this.error.manageBookingEmail = true;
            }

            if (!this.manageBooking.orderRef) {
                this.error.manageBookingOrderRef = true;
            }

            if (this.manageBooking.email && this.manageBooking.orderRef) {
                this.resetErrors();

                this.$router.push(`/manage/booking?order_ref=${this.manageBooking.orderRef}&email=${this.manageBooking.email}`);
            }
        },

        /** Find manage booking order **/
        findTechnicianTrackingOrder() {
            this.resetErrors();

            if (!this.technicianTracking.email) {
                this.error.technicianTrackingEmail = true;
            }

            if (!this.technicianTracking.orderRef) {
                this.error.technicianTrackingOrderRef = true;
            }

            if (this.technicianTracking.email && this.technicianTracking.orderRef) {
                this.resetErrors();

                this.$router.push(`/my/technician/${this.technicianTracking.email}/${this.technicianTracking.orderRef}`);
            }
        },

        /** Reset all errors **/
        resetErrors() {
            this.error.manageBookingEmail = false;
            this.error.manageBookingOrderRef = false;
            this.error.technicianTrackingEmail = false;
            this.error.technicianTrackingOrderRef = false;
        },

        /** Applies the selectable card class to the tabs **/
        tabItemClass(idx) {
            if (this.tabIndex === idx) {
                return ['selectable-card', 'active']
            } else {
                return ['selectable-card']
            }
        }
    }
}
</script>

<style scoped>

</style>